import { ShieldAlert, Flame, AlertTriangle, Info } from "lucide-react";

export const SEVERITY = {
  critical: { label: "Critical", color: "#FF3366", bg: "rgba(255,51,102,0.12)", icon: ShieldAlert },
  high: { label: "High", color: "#F59E0B", bg: "rgba(245,158,11,0.12)", icon: Flame },
  medium: { label: "Medium", color: "#EAB308", bg: "rgba(234,179,8,0.12)", icon: AlertTriangle },
  low: { label: "Low", color: "#06B6D4", bg: "rgba(6,182,212,0.12)", icon: Info },
};

export const STATUS = {
  open: { label: "Open", color: "#FF3366" },
  in_progress: { label: "In Progress", color: "#F59E0B" },
  remediated: { label: "Remediated", color: "#10B981" },
  false_positive: { label: "False Positive", color: "#94A3B8" },
};

export const scoreColor = (s) => {
  if (s >= 85) return "#10B981";
  if (s >= 70) return "#EAB308";
  if (s >= 50) return "#F59E0B";
  return "#FF3366";
};

export const scoreLabel = (s) => {
  if (s >= 85) return "SECURE";
  if (s >= 70) return "STABLE";
  if (s >= 50) return "AT RISK";
  return "CRITICAL";
};
